import React, { lazy, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import AccessibleNavigationAnnouncer from './components/AccessibleNavigationAnnouncer'
import SseHandler from './components/Application/Sse/Ssehandler'
import { useSelector } from 'react-redux'

const Layout = lazy(() => import('./containers/Layout'))
const Login = lazy(() => import('./pages/Login'))
const CreateAccount = lazy(() => import('./pages/CreateAccount'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))

function App() {
  let isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  console.log(isLoggedIn, "is logged in value")
  return (
    <>
      <Router>
        <AccessibleNavigationAnnouncer />
        <Routes>
          <Route path="/" element={isLoggedIn? <Layout />: <Navigate to="/login" />}  exact/>
          <Route path="/login" element={<Login />} exact/>
          {/* {!isLoggedIn && <Route to="/login" /> } */}
          <Route path="/create-account" element={CreateAccount} />
          <Route path="/forgot-password" element={ForgotPassword} />

          {/* Place new routes over this */}
          <Route path="/app/*" element={isLoggedIn? <Layout />: <Navigate to="/login" />} />
          {/* If you have an index page, you can remothis Redirect */}
          {/* <Navigate exact from="/" to="/login" /> */}
        </Routes>
      </Router>
      <SseHandler />
    </>
  )
}

export default App
